import Link from "next/link"
import { UnderlinedButton } from "../../Buttons/UnderlinedButton"
import UserIcon from "../../../public/images/icons/user.svg";
import { IconContainer } from "../../Buttons/IconContainer";
import styles from "./VerificationRequiredNotification.module.css";
import useTranslation from "next-translate/useTranslation";

export const VerificationRequiredNotification = () => {
    const { t } = useTranslation('common');

    return (
        <div className={styles.verified_notification}>
            <h4>{t('verify.alert.title')}</h4>
            <div>{t('verify.alert.subtitle')}</div>
            <UnderlinedButton renderContainer={(props) => <Link {...props} />} href="/user/verify" >
                <IconContainer responsiveText={false} icon={<UserIcon className="w-8 h-8 text-white stroke-[3px]" />} label={t('verify.alert.button')} />
            </UnderlinedButton>
        </div>
    )
}